import { useTheme } from '@emotion/react'
import { advisoryModuleStyles } from 'modules/Advisory/shared/styles'
import { Icon } from '../../features/Icons/Icon'

type ISnackBarType = 'Success' | 'Warning' | 'Failure' | 'Info'

export const SnackBar: React.FC<{
  type: ISnackBarType
  message: string
  actionButtonLabel?: string
  onActionButtonClicked?: () => void
  onDismissClicked?: () => void
}> = ({
  type,
  message,
  actionButtonLabel,
  onActionButtonClicked,
  onDismissClicked
}) => {
  const theme = useTheme()
  return (
    <div
      css={(theme) => ({
        background: `${
          type === 'Success'
            ? theme.colors.extraGreen1
            : type === 'Warning'
            ? theme.colors.secondaryYellow2
            : type === 'Failure'
            ? theme.colors.secondaryRed1
            : theme.colors.tertiaryBlue2
        }77`,
        padding: '10px',
        borderRadius: '4px',
        display: 'flex',
        justifyContent: 'space-between'
      })}
    >
      <div css={{ display: 'flex', gridColumnGap: 10, alignContent: 'center' }}>
        <Icon
          type={type}
          color={theme.colors.primaryWhite}
          height={22}
          width={22}
        />
        <div
          css={(theme) => [
            advisoryModuleStyles.fancyScroll,
            {
              fontSize: theme.size.lg,
              fontWeight: theme.fontWeights.regular,
              color: theme.colors.primaryWhite,
              lineHeight: '20px',
              maxHeight: '100px'
            }
          ]}
        >
          {message}
        </div>
      </div>
      <div css={{ display: 'flex', gridColumnGap: 10 }}>
        <div
          css={(theme) => ({
            fontSize: theme.size.lg,
            fontWeight: theme.fontWeights.medium,
            color: theme.colors.primaryWhite,
            cursor: 'pointer',
            lineHeight: '20px'
          })}
          onClick={onActionButtonClicked}
        >
          {actionButtonLabel}
        </div>
        {onDismissClicked && (
          <Icon
            type="CancelClose"
            width={18}
            height={18}
            color={theme.colors.primaryWhite}
            onClick={onDismissClicked}
          />
        )}
      </div>
    </div>
  )
}
